<template>
  <layout-public>
    <page-meta />

    <page-hero
      :crumbs="[{ label: t('Home'), href: route('index') }, { label: t('Blog') }]"
      :title="t('News & Insights')"
      :lede="t('Technology news, analysis and practical guides for small business owners, written in plain language and focused on what you can use this week.')"
    />

    <section class="blog-list">
      <div class="container">
        <!-- The pager belongs to the results, so it rides inside them: a list
             with nothing in it has no range to page and the empty message is the
             whole answer. One page still renders the row, so the pager shows for
             a single page too. -->
        <template v-if="posts.data.length">
          <div class="row gy-4">
            <div v-for="post in posts.data" :key="post.slug" class="col-md-6 col-lg-4" data-aos="fade-up">
              <post-card :post="post" :level="2" />
            </div>
          </div>

          <pagination :links="posts.links" />
        </template>

        <div v-else class="row">
          <div class="col-12 text-center">
            <p class="text-muted mb-0">{{ t('No posts yet.') }}</p>
          </div>
        </div>
      </div>
    </section>
  </layout-public>
</template>

<style lang="scss" scoped>
@import '~/_variables.scss';

.blog-list {
  background: $ground-tint;
}
</style>

<script>
import { useI18n } from 'vue-i18n';
import PageMeta from '@/Components/PageMeta.vue';
import LayoutPublic from '@/Layouts/Public.vue';
import PageHero from '@/Components/PageHero.vue';
import Pagination from '@/Components/Pagination.vue';
import PostCard from '@/Components/PostCard.vue';

export default {
  components: {
    LayoutPublic,
    PageHero,
    PageMeta,
    Pagination,
    PostCard
  },

  props: {
    posts: {
      type: Object,
      required: true
    }
  },

  setup() {
    const { t } = useI18n({
      messages: {
        'en-MY': {
          'News & Insights': 'News & Insights',
          'Technology news, analysis and practical guides for small business owners, written in plain language and focused on what you can use this week.': 'Technology news, analysis and practical guides for small business owners, written in plain language and focused on what you can use this week.',
          'No posts yet.': 'No posts yet.'
        },
        'zh-MY': {
          'News & Insights': '新闻与洞察',
          'Technology news, analysis and practical guides for small business owners, written in plain language and focused on what you can use this week.': '用白话写的科技文章，为中小企业老板而写，而不是写给工程师；每一篇都聚焦在您本周就能用得上的做法与细节，读完就能马上动手，把复杂的概念讲清楚。',
          'No posts yet.': '暂无文章。'
        },
        'ms-MY': {
          'News & Insights': 'Berita & Pandangan',
          'Technology news, analysis and practical guides for small business owners, written in plain language and focused on what you can use this week.': 'Berita, analisis dan panduan praktikal untuk pemilik perniagaan kecil, ditulis dalam bahasa mudah dan fokus pada apa yang berguna minggu ini.',
          'No posts yet.': 'Tiada artikel lagi.'
        }
      }
    });

    return { t };
  }
};
</script>
